document.addEventListener('DOMContentLoaded', function() {
  const universalDrawer = document.getElementById('cm-universal-drawer');
  if (!universalDrawer) return;

  const triggerSelector = '.cm-product__accordion-item.cm-accordion-item__description';

  const openDrawer = () => {
    universalDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden'; 
  };

  const closeDrawer = () => {
    universalDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', function(e) {
    const target = e.target.closest(triggerSelector);
    if (target) {
      e.preventDefault();
      openDrawer();
    }
  });

  const closeBtn = universalDrawer.querySelector('.cm-universal-drawer__close');
  const overlay = universalDrawer.querySelector('.cm-universal-drawer__overlay');

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
});